import * as React from 'react';
import { DashboardChartT } from 'business/definitions';
import { AlertAction } from './Contexts/AlertActionContext';
import AlertForm from './AlertForm/AlertForm';
import AlertEditForm from './AlertForm/AlertEditForm';
import AlertList from './AlertList';
import AlertStatusModal from './AlertStatus/AlertStatus';

type Props = {
    chart: DashboardChartT;
    chartTitle: string;
    action: AlertAction;
};

const ModalContent = ({ chart, chartTitle, action }: Props): JSX.Element => {
    if (action.name === 'create') {
        return <AlertForm chart={chart} chartTitle={chartTitle} />;
    }
    if (action.name === 'edit' && action.alertId) {
        return (
            <AlertEditForm
                chart={chart}
                alertId={action.alertId}
                chartTitle={chartTitle}
            />
        );
    }
    if (action.name === 'status' && action.alertId) {
        return <AlertStatusModal alertId={action.alertId} />;
    }
    return <AlertList chartKey={chart.key} />;
};

export default ModalContent;
